import { Action } from 'redux';

import { deepClone } from '~commonInfra/utils/DeepClone';

import { isUpdateShowWelcomeChannelAction } from '../../../home/actions/HomeActions';
import { isUpdateDataManagementAwarenessAction } from '../../../userSettings/actions/UpdateDataManagementAwarenessAction';
import { isRefreshSessionInfoAction } from '../actions/RefreshSessionInfoAction';
import { SessionState } from '../state/SessionState';

export const InitialState: SessionState = {
  info: null
};

export function sessionReducer(
    previousState: SessionState = InitialState,
    action: Action = null
): SessionState {

  if (isRefreshSessionInfoAction(action) && action.sessionInfo) {
    return {
      ...previousState,
      info: action.sessionInfo
    };
  }
  else if (isUpdateShowWelcomeChannelAction(action)) {
    const newState = deepClone(previousState);
    newState.info.user.showWelcomeScreen = action.showWelcomeChannel;
    return {
      ...newState
    };
  }
  else if (isUpdateDataManagementAwarenessAction(action)) {
    const newState = deepClone(previousState);
    newState.info.user.showPrepConductorAwareness = action.showPrepConductorAwareness;
    newState.info.user.showCatalogAwareness = action.showCatalogAwareness;
    return {
      ...newState,
    };
  } else {
    return previousState;
  }
}
